import React from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { countryFormat } from '../../../const/formatDate';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import { fillBlue } from '../../../utils/contrastSvgAttributes';
export const formatDate = (date: Date, isTime = true): JSX.Element => {
  return (
    <div
      style={{
        color: '#3C419A',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
      }}
    >
      <span style={{ color: 'rgba(44, 45, 62, 0.8)' }}>
        <TooltipOne title="Data" placement="top">
          <DateRangeIcon
            style={{
              color: fillBlue,
              width: '13px',
              height: '13px',
              marginRight: '3px',
            }}
            aria-controls="date-time-menu"
            aria-haspopup="true"
          />
        </TooltipOne>
        {date.toLocaleDateString(countryFormat)}
      </span>
      {isTime && (
        <span style={{ color: 'rgba(44, 45, 62, 0.8)' }}>
          <TooltipOne title="Godzina" placement="top">
            <AccessTimeIcon
              style={{
                color: fillBlue,
                width: '13px',
                height: '13px',
                marginRight: '3px',
              }}
              aria-controls="date-time-menu"
              aria-haspopup="true"
            />
          </TooltipOne>
          {date.toLocaleTimeString(countryFormat, {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      )}
    </div>
  );
};
